import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  CHANGE_PASSWORD,
  REAUTHENTICATE_CHANGE_PASSWORD,
  ADD_USER_SUCCESS,
  ADD_USER_REQUEST,
  ADD_USER_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USER_BY_ID,
  FETCH_USER_BY_ID_SUCCESS,
  CLEAR_USER_VALUES,
  UPDATE_USER_REQUEST,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
  SEARCH_USERS_REQUEST,
  SEARCH_USERS_SUCCESS,
  SEARCH_USERS_FAILURE,
  UPDATE_CURRENT_USER_REQUEST,
  FETCH_TOTAL_USERS_REQUEST,
  FETCH_TOTAL_USERS_SUCCESS,
  FETCH_TOTAL_USERS_FAILURE,
  CLEAR_TOTAL_USERS,
} from "./actionType";
import { UserType, TotalUsersType } from "../../core/entities/user";
import { initiateRequest } from "../request/action";
import { Query } from '../../core/entities/query';

export const fetchUsers = (query: Query) =>
  initiateRequest({
    type: FETCH_USERS_REQUEST,
    payload: { query },
  });

export const fetchUsersSuccess = (users: UserType[]) => ({
  type: FETCH_USERS_SUCCESS,
  payload: { users },
});

export const fetchUsersFailure = (error: string) => ({
  type: FETCH_USERS_FAILURE,
  payload: { error },
});

export const fetchUser = (id: string, isAdmin: boolean) =>
  initiateRequest({
    type: FETCH_USER,
    payload: { id, isAdmin },
  });

export const fetchUserSuccess = (user: any) => ({
  type: FETCH_USER_SUCCESS,
  payload: { user },
});

export const changePassword = (newPassword: string) =>
  initiateRequest({
    type: CHANGE_PASSWORD,
    payload: {
      newPassword,
    },
  });

export const reauthenticateChangePassword = (
  password: string,
  newPassword: string
) =>
  initiateRequest({
    type: REAUTHENTICATE_CHANGE_PASSWORD,
    payload: {
      password,
      newPassword,
    },
  });

export const addUserRequest = (user: any) =>
  initiateRequest({
    type: ADD_USER_REQUEST,
    payload: { user },
  });

export const addUserSuccess = () => ({
  type: ADD_USER_SUCCESS,
});

export const addUserFailure = (error: string) => ({
  type: ADD_USER_FAILURE,
  payload: { error },
});
export const fetchUserById = (id: string) =>
  initiateRequest({
    type: FETCH_USER_BY_ID,
    payload: { id },
  });

export const fetchUserByIdSuccess = (user: any) => ({
  type: FETCH_USER_BY_ID_SUCCESS,
  payload: { user },
});

export const clearUserValues = () => ({
  type: CLEAR_USER_VALUES,
});

export const updateUserRequest = (id: string, data: any, updateType: string) =>
  initiateRequest({
    type: UPDATE_USER_REQUEST,
    payload: { id, data, updateType },
  });

export const updateCurrentUserRequest = (id: string, data: any, updateType: string) =>
  initiateRequest({
    type: UPDATE_CURRENT_USER_REQUEST,
    payload: { id, data, updateType },
  });

export const updateUserSuccess = () => ({
  type: UPDATE_USER_SUCCESS,
});

export const updateUserFailed = () => ({
  type: UPDATE_USER_FAILED,
});

export const searchUsers = (keyword: string) =>
  initiateRequest({
    type: SEARCH_USERS_REQUEST,
    payload: { keyword },
  });

export const searchUsersSuccess = (users: UserType[]) => ({
  type: SEARCH_USERS_SUCCESS,
  payload: { users },
});

export const searchUsersFailure = (error: string) => ({
  type: SEARCH_USERS_FAILURE,
  payload: { error },
});

export const fetchTotalUsersRequest = () => ({
  type: FETCH_TOTAL_USERS_REQUEST
});

export const fetchTotalUsersSuccess = (data: TotalUsersType) => ({
  type: FETCH_TOTAL_USERS_SUCCESS,
  payload: { data },
});

export const fetchTotalUsersFailure = (error: string) => ({
  type: FETCH_TOTAL_USERS_FAILURE,
  payload: { error }
});

export const clearTotalApplicants = () => ({
  type: CLEAR_TOTAL_USERS
});
